import {
  EN_EXTERNAL_PRICING_URL,
  MARKET,
  SE_EXTERNAL_PRICING_URL,
} from "@/constants";
import { Organization } from "@/types/Organization";

export function getExternalPricingURL(
  country?: Organization["country"]
): string {
  if (country === MARKET.SWEDEN) {
    return SE_EXTERNAL_PRICING_URL;
  }

  return EN_EXTERNAL_PRICING_URL;
}
